export default __webpack_public_path__ + "static/media/tip.680462eb.svg";